import { cn } from '@/lib/utils';

export type TimePeriod = '3M' | '6M' | '1Y' | 'ALL';

const PERIODS: TimePeriod[] = ['3M', '6M', '1Y', 'ALL'];

interface TimelineToggleProps {
  selected: TimePeriod;
  onChange: (period: TimePeriod) => void;
}

export function TimelineToggle({ selected, onChange }: TimelineToggleProps) {
  return (
    <div className="flex gap-1 rounded-lg bg-muted p-1 w-fit" role="group" aria-label="Select time period">
      {PERIODS.map((period) => {
        const isActive = period === selected;
        return (
          <button
            key={period}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(period)}
            className={cn(
              'px-3 py-1 rounded-md text-sm font-medium transition-colors',
              isActive
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {period}
          </button>
        );
      })}
    </div>
  );
}
